import { useCallback } from 'react';

export const useAuth = () => {
    const clearAuthState = useCallback(() => {
        // Clear all authentication-related items from localStorage
        const authItems = [
            'token',
            'currentBusiness',
            'googleCredential',
            'selectedBusiness',
            'providerUser'
        ];

        authItems.forEach(item => localStorage.removeItem(item));

        // Clear session storage
        localStorage.clear();

        // Clear any cookies related to authentication
        document.cookie.split(";").forEach(cookie => {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
    }, []);

    return { clearAuthState };
}; 